import { useEffect } from "react";
import { Link } from "react-router-dom";
import AgBanho from "../img/__AgBanho.svg";
import AgConsulta from "../img/__AgConsulta.svg";
import AgPetShop from "../img/__AgPetShop.svg";
import Styles from "../styles/mainContent.module.css";
import Depoimentos from "./Depoimentos";

const MainContent = () => {
  useEffect(() => {
    // Recarrega o script do Instagram quando o componente monta
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <div className={Styles.animacao}>
        <video autoPlay muted loop>
          <source src="/img/Video.mp4" type="video/mp4" />
          Seu navegador não suporta vídeos.
        </video>
      </div>

      <div className={Styles.cta}>
        <ul>
          <li>
            <a
              href="https://wa.me/553491026420"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AgConsulta} alt="Agendar Consulta" width="500" />
            </a>
          </li>
          <li>
            <a
              href="https://wa.me/553491026420"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AgBanho} alt="Agendar Banho" width="500" />
            </a>
          </li>
          <li className={Styles.tooltipContainer}>
            <Link to="/petshop" className={Styles.linkPetshop}>
              <img src={AgPetShop} alt="Pet Shop" width="500" />
              <span className={Styles.tooltip}>Em breve</span>
            </Link>
          </li>
        </ul>
      </div>

      <Depoimentos />
    </>
  );
};

export default MainContent;
